<script setup>
import { computed, ref } from "vue"
import { PrimaryButton } from "@codinglabsau/ui"
import { AdjustmentsHorizontalIcon } from "@heroicons/vue/24/solid"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import AlgoliaSearch from "@/Components/Inputs/BlockEditor/Extension/Components/AlgoliaSearch.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  state: {
    type: String,
    default: null
  },
  indexOptions: {
    required: true,
  },
  defaultIndex: {
    required: true,
  },
  variantFilters: {
    type: Object,
  }
})

const emits = defineEmits(['update:state', 'hits'])

let computedState = computed({
  get() {
    return props.state
  },
  set(value) {
    emits('update:state', value)
  }
})

let showDialogue = ref(false)

const onHitsUpdated = (hits) => {
  emits('hits', hits)
}
</script>

<template>
  <ToolbarButton
    :label="__('Edit Algolia Filters')"
    :icon="AdjustmentsHorizontalIcon"
    v-model="showDialogue"
  />
  <Modal :unmount="false" size="max-w-7xl" v-model="showDialogue">
    <template #title>
      {{ __('Configure Algolia Filters') }}
    </template>
    <div v-once>
      <AlgoliaSearch
        v-model="computedState"
        :default-index="defaultIndex"
        :index-options="indexOptions"
        @hits="onHitsUpdated"
        :variant-filters="variantFilters"
      ></AlgoliaSearch>
    </div>
    <div class="space-x-2">
      <PrimaryButton
        class="mt-2"
        as="button"
        type="button"
        @click.prevent="showDialogue = false"
      >
        {{ __('Done') }}
      </PrimaryButton>
    </div>
  </Modal>
</template>

